import React from "react";
import { ViewMoreP2PInfo } from "../../../pages";

const ViewMoreP2PInfoContainer = ({ singleItem, closeModal }) => {
  return <ViewMoreP2PInfo singleItem={singleItem} closeModal={closeModal} />;
};

export default ViewMoreP2PInfoContainer;
